<template>
    <div class="tenantMain tenantThanks">
        <div class="tenantCard tenantWelcome text-center">
            <div class="header">
                <img src="/img/tenants-logo.png" alt="">
            </div>
            <div class="main">
                <p class="mb-1"><b>Thank you</b> for your feedback</p>
                <template v-if="userLogged">
                    <p class="mb-1">After 60 seconds, the system will automatically log out. If you don't have any follow-up activities</p>
                    <p class="mb-0 text-center text-highlight" v-if="minute >= 0">{{ minute | formatCountDown }}</p>
                </template>
            </div>
            <div class="footer">
                <gofix-button class="mw-250" label="Logout" large @click="logOut" outline v-if="userLogged"></gofix-button>
                <gofix-button class="mw-250" label="Submit another feedback" large @click="nextStep"></gofix-button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'tenant-thanks',
        props: {
            userLogged: {
                type: Object,
                default: () => null
            },
            minute: {
                type: Number,
                default: 0
            }
        },
        data () {
            return {}
        },
        filters: {
            formatCountDown(val) {
                if(val == 60) 
                    return '01:00';
                if(val < 10) 
                    return `00:0${val}`;
                if(val < 0) 
                    return '00:00';
                return `00:${val}`;
            }
        },
        created() {},
        methods:{
            nextStep(){
                this.$emit("next-step");
            },
            logOut() {
                this.$emit("logout");
            }
        }
    }
</script>
